import { t } from 'services/i18n.service';
import ModalOverlay from './shared/ModalOverlay';
import { SPINNER } from 'enums';
import colors from 'constants/color';
import { ATTRIB } from 'constants/test';
import LoadingIndicator from './common/LoadingIndicator';

interface Props {
  title?: string;
  containerStyles?: string;
  messageStyles?: string;
  fillSpinner?: string;
  type?: SPINNER;
}

const DotWave = () => {
  return (
    <div
      className='inline-flex w-[8vh] h-[8vh] aspect-[2/1] animate-dotWave'
      style={{
        background: `
          radial-gradient(circle closest-side, ${colors.PRIMARY.LIGHT_500} 90%, transparent 100%) 0% 50%,
          radial-gradient(circle closest-side, ${colors.PRIMARY.LIGHT_500} 90%, transparent 100%) 50% 50%,
          radial-gradient(circle closest-side, ${colors.PRIMARY.LIGHT_500} 90%, transparent 100%) 100% 50%
        `,
        backgroundSize: '25% 50%',
        backgroundRepeat: 'no-repeat'
      }}
    />
  );
};

const OverlaySpinner = ({
  title,
  messageStyles = 'text-primary-900',
  containerStyles = 'w-screen h-screen flex items-center justify-center',
  type = SPINNER.DEFAULT
}: Props) => {
  const message = title ?? t('updating');

  const loaders = {
    [SPINNER.DEFAULT]: (
      <LoadingIndicator dims='min-w-5 ~w-5/7 min-h-5 ~h-5/7 ~top-1.5/2.5' />
    ),
    [SPINNER.DOT_WAVE]: <DotWave />
  };

  return (
    <ModalOverlay
      styles={`${containerStyles} bg-gray-900/80 dark:bg-gray-600/80`}
      zIndex='z-[99999]'
      data-testid={ATTRIB.DATA_TESTID.OVERLAY_SPINNER}>
      <div className='w-fit flex flex-col xs:flex-row justify-center items-center ~gap-1/4 ~px-4/16'>
        {loaders[type]}
        <h4
          className={`~text-base/2xl ${messageStyles} text-primary-900 text-center`}>
          {message}
        </h4>
      </div>
      <span className='sr-only'>{message}</span>
    </ModalOverlay>
  );
};

export default OverlaySpinner;
